import { FC, useMemo } from 'react';
import Modal from 'shared/components/andtComponents/Modal';
import { ResourceData } from '../../types';

export interface BulkDeleteConfirmationModalProps {
  isOpen: boolean;
  selectedResources: ResourceData[];
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

interface ModalContentProps {
  resourcesWithTags: ResourceData[];
}

const ModalContent: FC<ModalContentProps> = ({ resourcesWithTags }) => {
  if (resourcesWithTags.length === 0) {
    return <div>No virtual tags to remove from the selected resources.</div>;
  }

  if (resourcesWithTags.length === 1) {
    return (
      <div>
        Are you sure you want to remove all virtual tags from the selected resource?
        <br />
        <br />
        This action cannot be undone.
      </div>
    );
  }

  return (
    <div>
      Are you sure you want to remove all virtual tags from {resourcesWithTags.length} selected resources?
      <br />
      <br />
      This action cannot be undone.
    </div>
  );
};

export const BulkDeleteConfirmationModal: FC<BulkDeleteConfirmationModalProps> = ({
  isOpen,
  selectedResources,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  const resourcesWithTags = useMemo(
    () => selectedResources.filter((resource) => resource?.governanceTags?.length > 0),
    [selectedResources],
  );

  return (
    <Modal
      title="Remove Virtual Tags"
      saveTitle="Remove"
      onClose={onClose}
      open={isOpen}
      onSave={onConfirm}
      saveWarning
      saveDisabled={resourcesWithTags.length === 0 || isLoading}
      isLoading={isLoading}
    >
      <ModalContent resourcesWithTags={resourcesWithTags} />
    </Modal>
  );
};

export default BulkDeleteConfirmationModal;
